import { Copy, Check } from 'lucide-react';
import { useState } from 'react';

const TransactionMessage = ({ transactionId, statusMessage, error }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (transactionId) {
      navigator.clipboard.writeText(transactionId);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500); // reset after 1.5s
    }
  };

  return (
    <div className="text-center bg-muted/20 rounded-md space-y-2">
      {transactionId && (
        <div className="flex justify-center items-center gap-2">
          <span className="font-medium text-gray-700 dark:text-gray-300">Transaction ID:</span>
          <span className="text-sm bg-gray-100 dark:bg-gray-800 px-2 py-1 rounded">{transactionId}</span>
          <button
            onClick={handleCopy}
            className="text-gray-600 hover:text-teal-600 dark:text-gray-300 dark:hover:text-teal-400 transition"
            aria-label="Copy transaction ID">
            {copied ? <Check size={18} /> : <Copy size={18} />}
          </button>
          {copied && <span className="text-xs text-teal-600 dark:text-teal-400 ml-2 animate-fade-in">Copied!</span>}
        </div>
      )}
      {statusMessage && <p className="text-teal-600 dark:text-teal-400 font-medium">{statusMessage}</p>}
      {error && <p className="text-red-500 text-sm font-medium">{error}</p>}
    </div>
  );
};

export default TransactionMessage;
